<template>
  <article>
    <ArticleMastHead
      :title="artwork.title"
      :cover_media="artworkCoverMedia"
      :articleID="artwork.id"
      :referenceType="1"
    />
    <FieldArtwork
      :isMobile="isMobile"
      :temple="artwork.related_temples[0].name"
      :space="artwork.space"
      :identity="artwork.identity"
    />

    <ArticleContainer>
      <template #main>
        <ArticleParagraphs
          category="artwork"
          :paragraphs="artwork.paragraphs"
        ></ArticleParagraphs>
      </template>
      <template #aside>
        <ArtworkAside :isMobile="isMobile" />
      </template>
    </ArticleContainer>
  </article>
</template>

<script>
// import { lazyloading } from '@/utils/lazyloading';

import ArticleMastHead from '@/components/article/ArticleMastHead';
import ArticleParagraphs from '@/components/article/ArticleParagraphs';
import ArticleContainer from '@/components/article/ArticleContainer';
import ArtworkAside from '@/components/aside/ArtworkAside';
import FieldArtwork from '@/components/aside/FieldArtwork';

export default {
  name: 'TheArtwork',
  metaInfo() {
    return {
      title: this.artwork.title ? `${this.artwork.title} - 藝品導覽` : '藝品導覽',
      meta: [
        {
          vmid: 'og:url',
          property: 'og:url',
          content: this.productionWholeReference,
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: `${this.artwork.title} | 臺南宗教藝術`,
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: this.artwork.paragraphs[0].content,
        },
        {
          vmid: 'og:image',
          property: 'og:image',
          content: this.artwork.cover_image_url,
        },
      ],
    };
  },
  data() {
    return {};
  },
  computed: {
    artwork() {
      return this.$store.getters.artwork;
    },
    artworkCoverMedia() {
      return this.$store.getters.getCoverMedia('artwork');
    },
    productionWholeReference() {
      return `${this.$store.getters.productionHostname}${window.location.pathname}${window.location.search}`;
    },
    windowWidth() {
      return this.$store.getters.windowWidth;
    },
    isMobile() {
      return this.windowWidth < 1440;
    },
  },
  async mounted() {
    await this.getArtworkData(this.$route.params.articleId);
    // await lazyloading();
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.articleId !== from.params.articleId) {
      this.getArtworkData(to.params.articleId);
    }
    next();
  },
  methods: {
    async getArtworkData(articleId) {
      // 載入藝品文章頁內頁，以 API 資料作為初始值
      try {
        await this.$store.dispatch('getArtWork', articleId);
      } catch (e) {
        console.error(e);
      }
    },
  },
  components: {
    ArticleMastHead,
    ArticleParagraphs,
    ArticleContainer,
    ArtworkAside,
    FieldArtwork,
  },
};
</script>
<style scoped lang="scss">
/deep/.article-head__title {
  h2 {
    @include for-desktop {
      margin: 10px;
    }
  }
}
</style>
